import { Injectable } from '@angular/core';
import { CalendarModel } from '../models/calendar.model';
import { DateUtils } from 'src/app/utils/date-utils';

export type CalendarModelList = CalendarModel & {
  diasSinServicio: string
  diasConServicio: string
}

@Injectable({
  providedIn: 'root'
})
export class CalendarTransformerService {

  public transform(calendario: CalendarModel): CalendarModelList {
    const diasSinServicio = calendario.diasEspecialesSinServicio
    .map(dia => DateUtils.formatDate(dia.fecha, true))
      .join(', ');

    const diasConServicio = calendario.diasEspecialesConServicio
      .map(dia => DateUtils.formatDate(dia.fecha, true))
      .join(', ');

    return {
      ...calendario,
      diasSinServicio: diasSinServicio,
      diasConServicio: diasConServicio
    }
  }
}
